// First slot is the brand IPSAT green and shows up as the IPSAT-1.0 score
// slice in the dashboard donut chart, which sits next to the 2.0 wheel that
// already uses #1ab394. Steve 2026-06-11 ask: keep the IPSAT green
// consistent across dashboard + report — so the donut now matches the
// wheel/report instead of the older #24d37b shade.
export const CHART_COLORS = [
  '#1ab394',
  '#f55f63',
  '#524fdb',
  '#2e7ef0',
  '#fcd14c',
  '#eee',
];
export const PVI_BAR_CHART_COLORS = [
  '#208278',
  '#8e3551',
  '#ff9239',
  '#1dcfdd',
];
export const PVI_BAR_CHART_COLORS_TRANSPARENT = [
  'rgba(32,130,120,.2)',
  'rgba(142,53,81,.2)',
  'rgba(255,146,57,.2)',
  'rgba(29,207,221,.2)',
];
